import React from 'react'

const useReportProblem = type => {
  switch (type) {
    case '404':
      type = '404'
      break
    default:
      type = 'Undefined'
  }

  // const {isOpen, onOpen, onClose} = useReportProblemModal()
  const ReportItem = () => {
    return <div>
      
    </div>
  }
  return {
    ReportItem,
    type
  }
}

export default useReportProblem
